export default __webpack_public_path__ + "static/media/zbizLogo.ca3aeb74.png";